import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../store";
import { hideApplicant } from "../../../reducers/profile";
import defaultContent from "../../../content/profile";
import LeafPanel from "../../../common/leaf/LeafPanel/LeafPanel";
import CustomerApplicantBody from "./CustomerApplicantBody";

const CustomerApplicantSlider = () => {
  const { t } = useTranslation(["profile", "common"]);

  const dispatch = useAppDispatch();

  const closeApplicant = () => {
    dispatch(hideApplicant());
  };

  const isShowApplicant = useAppSelector((state) => state.profile.isShowApplicant);
  const profileType = useAppSelector((state) => state.profile.profileType);

  const showSlider = isShowApplicant && profileType === "customer";

  return (
    <>
      <LeafPanel
        title={`${t("customerProfile.allApplicant", defaultContent["customerProfile"]["allApplicant"])}`}
        show={showSlider}
        onCloseClick={closeApplicant}
        id={"applicant-slider"}
        showBackdrop={false}
        applyScroll={true}
      >
        <CustomerApplicantBody isShowApplicant={showSlider} />
      </LeafPanel>
    </>
  );
};

export default CustomerApplicantSlider;
